<template>
  <lists-page :suppression="true" />
</template>

<script>
import ListsPage from '@/modules/lists/pages/ListsPage'
export default {
  components: { ListsPage }
}
</script>



// WEBPACK FOOTER //
// src/modules/lists/pages/ListsPageSuppression.vue